import React, { useState, useEffect } from 'react';

const CommentPanel= () => {
  const [formData, setFormData] = useState({
    username: '',
    nationality: '',
    comment: '',
  });

  const [comments, setComments] = useState(null)

  const [status, setStatus] = useState(null);
  const [errors, setErrors] = useState([]);

  const [countries, setCountries] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setErrors([]);

    try {
      const response = await fetch('https://dzwiekowamapabialegostokuapi.pb.edu.pl/api/v1/comments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ comment: formData }),
      });

      if (!response.ok) {
        const data = await response.json();
        setErrors(data.errors || ['Something went wrong.']);
        setStatus('error');
      } else {
        setFormData({ username: '', nationality: '', comment: '' });
        setStatus('success');
      }
    } catch (err) {
      setErrors(['Failed to submit.']);
      setStatus('error');
    }
  };

  useEffect(async () => {
    const comment_response = await fetch("https://dzwiekowamapabialegostokuapi.pb.edu.pl/api/v1/comments", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    }) 

    try{

      const comments = await comment_response.json();

      setComments(comments)

    }catch(err){
      setComments(null)
    }

    const country_response = await fetch("./countries_polish.json", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })

    try{
      const countries = await country_response.json()

      countries.sort((a,b) => a.name.localeCompare(b.name))
      console.log(countries)

      setCountries(countries)
    }catch(err){
      setCountries(null)
    }


  }, []);

  return (
    <div>

      <style>
        {`
          .dark-placeholder-text::placeholder {
            color: #000;
          }

          .dark-text{
            color: #000;
          }
        `}
      </style>

      <div className="container mt-4">
        <div className="border rounder bg-light p-3" style={{maxHeight: "400px", overflowY: "auto"}}>
          {comments && 
            comments.map((comment) => (
              (
                <div key={comment.id} className='mb-3 p-3 bg-white border rounded shadow-sm'> 
                  <div>
                    <div className='d-flex justify-content-between align-items-center mb-2 w-100 overflow-hidden text-nowrap'>
                      <span className='mr-2 ' style={{    overflow: 'hidden', textOverflow: 'ellipsis'}}> {comment.username}:</span>
                      <span className='text-muted'> {countries.find(c => c.name == comment.nationality)?.flag || comment.nationality} </span>
                    </div>
                    <small className='text-muted'>
                      {new Date(comment.created_at).toLocaleString()}
                    </small>
                  </div>
                  <p className='mb-0'> {comment.comment} </p>
                </div>
              )  
            ))
          }
        </div>
      </div>

      <form
        className="container p-4 bg-white mt-5"
        style={{minWidth: '300px' }}
        onSubmit={handleSubmit}
      >
        <h3 className="fw-bold border-bottom pb-2 mb-4">Twoja wiadomość</h3>

        <div className="mb-4">
          <input
            type="text"
            id="username"
            name="username"
            placeholder="Nick"
            value={formData.username}
            onChange={handleChange}
            maxLength={100}
            required
            className="form-control rounded-0 dark-placeholder-text dark-text"
            style={{
              border: 'none',
              borderBottom: '1px solid #000',
              backgroundColor: 'transparent'
            }}
          />
        </div>

        <div className="mb-4">
          <select
            id="nationality"
            name="nationality"
            value={formData.nationality}
            onChange={handleChange}
            className="form-control rounded-0 dark-placeholder-text dark-text"
            style={{
              border: 'none',
              borderBottom: '1px solid #000',
              backgroundColor: 'transparent',
              cursor: 'pointer'
            }}
          >

          <option value="" selected disabled hidden>Kraj zamieszkania</option>

          {countries && countries.map((country, index) => (
            (
              <option key={index} value={country.name}> {country.name} {country.flag}  </option>
            )
          ))}

          </select>
        </div>

        <div className="mb-4">
          <textarea
            name="comment"
            placeholder="Twoja myśl..."
            value={formData.comment}
            onChange={handleChange}
            maxLength={5000}
            required
            className="form-control bg-light text-dark dark-placeholder-text dark-text"
            rows="5"
            style={{ borderColor: '#000'}}
          />
        </div>

        <div className="d-flex justify-content-end gap-3 mb-4">
          <button
            type="submit"
            className="btn btn-outline-dark fw-semibold px-4"
            style={{
              transition: 'all 0.2s ease-in-out',
              backgroundColor: '#fff',
              borderColor: '#000',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#111';
              e.target.style.color = '#fff';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#fff';
              e.target.style.color = '#000';
            }}
          >
            Publikuj
          </button>
        </div>

        {status === 'success' && <p className="text-success">Dziękujemy! Twój komentarz został przesłany!</p>}
        {status === 'error' && (
          <div className="text-danger">
            <p>Wystąpił problem:</p>
            <ul>
              {errors.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}
      </form>


    </div>
  );
};

export default CommentPanel;
